



































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { listReq } from "@/common/class/h5/joblist/index";
import { getPublishedItinerary } from "@/api/scheduleManagement/index";
import { getScheduleJobList, getAllJobList } from "@/api/joblist/index";
import { deliverResume, getJobs } from "@/api/h5/index";
import topItem from "@/components/common/header/index.vue";
import { Cell } from "vant";
import { Pagination, Loading, Toast } from "vant";
import { addDeliverReq } from "@/common/class/h5/index";

@Component({
  components: {
    [Cell.name]: Cell,
    [Pagination.name]: Pagination,
    [Loading.name]: Loading,
    topItem,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  finished = false;
  list = new DataParse();
  req: any = new listReq();
  showDetail = false;
  detailContent = "";
  componentName = topItem;
  //行程id
  id: any = "";
  tableloading: boolean = false;
  tableData = new DataParse();
  jobName: any = "";
  jobRequirements: any = "";
  jobDescription: any = "";
  jobRequirementsArr: Array<any> = [];
  jobDescriptionArr: Array<any> = [];
  addReq = new addDeliverReq();
  timer: any = "";

  created() {
    this.init();
  }
  beforeDestroy() {
    clearInterval(this.timer);
  }
  async init() {
    if (this.$route.query.id) {
      this.req.itineraryId = this.$route.query.id;
      await this.getList();
    } else {
      await this.getAllList();
    }
    this.jobName = this.tableData.listItem[0].jobName;
    this.addReq.itineraryId = this.tableData.listItem[0].itineraryId;
    this.addReq.jobId = this.tableData.listItem[0].jobId;
    this.addReq.jobName = this.tableData.listItem[0].jobName;
    this.jobRequirements = this.tableData.listItem[0].jobRequirements;
    this.jobDescription = this.tableData.listItem[0].jobDescription;
    this.jobRequirementsArr = this.handleText(this.jobRequirements);
    this.jobDescriptionArr = this.handleText(this.jobDescription);
  }

  // 获取某个行程的岗位列表
  getList() {
    this.tableloading = true;
    return getScheduleJobList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data;
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }
  //获取全部岗位列表
  getAllList() {
    this.tableloading = true;
    return getAllJobList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data;
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }

  handleRowClick(row: any, col: any) {
    this.jobName = row.jobName;
    this.addReq.itineraryId = row.itineraryId;
    this.addReq.jobId = row.jobId;
    this.addReq.jobName = row.jobName;
    this.jobRequirements = row.jobRequirements;
    this.jobDescription = row.jobDescription;
    this.jobRequirementsArr = this.handleText(this.jobRequirements);
    this.jobDescriptionArr = this.handleText(this.jobDescription);
  }
  //对后台返回的文本内容进行切割处理
  handleText(text: any) {
    if (text) {
      return text.split("\n");
    }
  }
  onSubmit(value: any) {
    let token = localStorage.getItem("token");
    if (token) {
      this.loading = true;
      deliverResume(this.addReq)
        .then((res) => {
          const { data, message, success } = res;
          if (success) {
            Toast.success("投递成功！");
            /*           this.$router.push({ path: "itineraryDetail", query: { id: this.addReq.itineraryId } }); */
          } else {
            Toast.success(message);
       /*      setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 1000); */
          }
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      Toast.success("请登录!");
      this.timer = setInterval(() => {
        this.$router.push({ path: "/login" });
      }, 1000);
    }
  }
  goBack() {
    this.$router.push("home");
  }

  mounted() {}
}
